import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux'

class Loading extends Component {
	render() {
		let width = this.props.width ? this.props.width : '100%'
		let height = this.props.height ? this.props.height : '50%'

		return (
			<div style={{position: 'relative', width, paddingTop: height}}>
				<svg style={{width: 75, height: 75, position: 'absolute', transform: 'translate(-50%, -50%)', top: '50%', left: '50%'}} version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50">
					<path fill="#00ffff" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(187.103 25 25)">
						<animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite" />
					</path>
				</svg>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {};
}

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Loading);
